import React from 'react';
import { FiX, FiMinimize2, FiMaximize2 } from 'react-icons/fi';
import './Modals.css';

const ImageModal = ({ 
  isOpen, 
  onClose, 
  patientImage, 
  selectedCase,
  imageZoom,
  onZoomIn,
  onZoomOut,
  onResetZoom 
}) => {
  if (!isOpen || !patientImage) return null;

  return (
    <div className="modal-overlay image-overlay" onClick={onClose}>
      <div className="image-modal" onClick={(e) => e.stopPropagation()}>
        <div className="image-modal-header">
          <div className="image-title">
            <h3>Patient Image - {selectedCase?.name}</h3>
          </div>
          <div className="image-controls">
            <button className="control-btn" onClick={onZoomOut} title="Zoom Out">
              <FiMinimize2 size={18} />
            </button>
            <button className="control-btn" onClick={onResetZoom} title="Reset Zoom">
              {imageZoom.toFixed(1)}x
            </button>
            <button className="control-btn" onClick={onZoomIn} title="Zoom In">
              <FiMaximize2 size={18} />
            </button>
            <button className="close-image-btn" onClick={onClose}>
              <FiX size={20} />
            </button>
          </div>
        </div>
        
        <div className="image-modal-body">
          <div className="image-viewer">
            <img 
              src={patientImage} 
              alt={selectedCase?.name}
              className="patient-image"
              style={{ transform: `scale(${imageZoom})` }}
            />
            <div className="image-overlay-info">
              <div className="patient-summary">
                <h4>{selectedCase?.name}</h4>
                <p>{selectedCase?.age} years</p>
              </div>
            </div>
          </div>
        </div>
        
        <div className="image-modal-footer">
          <div className="zoom-info">
            <span>Zoom: {imageZoom.toFixed(1)}x</span>
            <span>Use buttons or mouse wheel to zoom</span>
          </div>
          <div className="footer-actions">
            <button 
              className="btn-secondary"
              onClick={onClose}
            >
              Close
            </button>
            <button 
              className="btn-primary"
              onClick={() => window.open(patientImage, '_blank')}
            >
              Open Full Size
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImageModal;